/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_ConcretingRequestMessage,
  ListCommandResult_ConcretingRequestMessage
} from "@graphql/helpers/types.graphql";
import {
  CommandResult,
  ListCommandResult
} from "@graphql/groups/fragment.graphql";
import utils, {
  TNonEmptyArray,
  TJoin,
  TConcretingRequestType,
  TConcretingRequestMessageType,
  TUserType
} from "@graphql/helpers/utils.graphql";

type TGlobal =
  | TConcretingRequestMessageType
  | TJoin<"concretingRequest", TConcretingRequestType>
  | TJoin<"user", TUserType>;

type TConcretingRequestMessageByIdFunctions = {
  getByID: CommandResult_ConcretingRequestMessage;
};
export type TConcretingRequestMessageByIdQueries = {
  concretingRequestMessage: TConcretingRequestMessageByIdFunctions;
};

export const concretingRequestMessageById = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query concretingRequestMessageById($id: Guid!) {
    concretingRequestMessage {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ConcretingRequestMessage")}
`;

type TConcretingRequestMessageAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_ConcretingRequestMessage;
};
export type TConcretingRequestMessageAllWithPaginationQueries = {
  concretingRequestMessage: TConcretingRequestMessageAllWithPaginationFunctions;
};
export const concretingRequestMessageAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query concretingRequestMessageAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    concretingRequestMessage {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ConcretingRequestMessage")}
`;
